<template>
  <div class="solutions-section">
    <div class="solutions-inner">
      <p class="p1">— {{ $t("home.v2.solutions.eyebrow") }}</p>
      <div class="solutions-content">
        <div class="title-line">
          <p class="p2">{{ $t("home.v2.solutions.title1") }}</p>
          <p class="p3">{{ $t("home.v2.solutions.title2") }}</p>
        </div>
        <div class="solutions-btn" @click="openExternal('https://about.rwa.ltd/consumer-rwa.html')">
          <p class="p4">{{ $t("home.v2.solutions.link") }}</p>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="solutions-img">
      <div v-for="item in listData" :key="item.id" class="solutions-item" @click="openExternal('https://about.rwa.ltd/consumer-rwa.html')">
        <div>
          <img :src="item.icon" :alt="item.title" />
          <h3 class="solutions-title">{{ item.title }}</h3>
          <p class="solutions-desc">{{ item.desc }}</p>
        </div>
        <div class="solutions-btn">
          <p>{{ item.btnText }}</p>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SolutionsSection",
  computed: {
    listData() {
      return [
        {
          id: 1,
          icon: require("@/assets/img/images/home/solutions1.png"),
          title: this.$t("home.v2.solutions.items.issuance.title"),
          desc: this.$t("home.v2.solutions.items.issuance.desc"),
          btnText: this.$t("home.v2.solutions.items.commonExplore"),
        },
        {
          id: 2,
          icon: require("@/assets/img/images/home/solutions2.png"),
          title: this.$t("home.v2.solutions.items.materials.title"),
          desc: this.$t("home.v2.solutions.items.materials.desc"),
          btnText: this.$t("home.v2.solutions.items.commonExplore"),
        },
        {
          id: 3,
          icon: require("@/assets/img/images/home/solutions3.png"),
          title: this.$t("home.v2.solutions.items.deployment.title"),
          desc: this.$t("home.v2.solutions.items.deployment.desc"),
          btnText: this.$t("home.v2.solutions.items.commonExplore"),
        },
        {
          id: 4,
          icon: require("@/assets/img/images/home/solutions4.png"),
          title: this.$t("home.v2.solutions.items.launch.title"),
          desc: this.$t("home.v2.solutions.items.launch.desc"),
          btnText: this.$t("home.v2.solutions.items.commonExplore"),
        },
        {
          id: 5,
          icon: require("@/assets/img/images/home/solutions5.png"),
          title: this.$t("home.v2.solutions.items.circulation.title"),
          desc: this.$t("home.v2.solutions.items.circulation.desc"),
          btnText: this.$t("home.v2.solutions.items.commonExplore"),
        },
        {
          id: 6,
          icon: require("@/assets/img/images/home/solutions6.png"),
          title: this.$t("home.v2.solutions.items.redemption.title"),
          desc: this.$t("home.v2.solutions.items.redemption.desc"),
          btnText: this.$t("home.v2.solutions.items.commonExplore"),
        },
      ];
    },
  },
  methods: {
    openExternal(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.solutions-section {
  padding: 100px 60px;
  background: #ffffff;
  box-sizing: border-box;
}
.solutions-inner {
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
  }
}
.solutions-content {
  display: flex;
  flex-wrap: wrap;
  row-gap: 16px;
  align-items: flex-end;
  justify-content: space-between;
  .title-line {
    display: flex;
    align-items: baseline;
    gap: 16px;
    p {
      margin: 0;
    }
  }
  .p2 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    line-height: 1.35;
    color: #333333;
    white-space: nowrap;
  }
  .p3 {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: clamp(32px, 2.75vw, 60px);
    color: #E05807;
    line-height: 1.35;
    white-space: nowrap;
  }
  .p4 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
  }
  .solutions-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid #333333;
    p {
      padding-bottom: 12px;
    }
    i {
      font-size: 24px;
      color: #333333;
      margin-left: 8px;
    }
  }
}

.solutions-img {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  padding-top: 48px;
  .solutions-item {
    height: 460px;
    display: flex;
    cursor: pointer;
    border-left: none;
    background: #ffffff;
    flex-direction: column;
    border: 1px solid #dcdbd9;
    padding: 40px 22px 22px 22px;
    justify-content: space-between;
    img {
      width: 94px;
      height: 94px;
      margin-bottom: 24px;
    }
    .solutions-title {
      font-weight: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 26px;
      color: #333333;
      margin-bottom: 12px;
    }
    .solutions-desc {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
    }
  }
  .solutions-item:first-child {
    border-left: 1px solid #dcdbd9;
  }
  .solutions-item:hover {
    background: #E05807;
    .solutions-title {
      color: #ffffff;
    }
    .solutions-desc {
      color: #ffffff;
    }
    .solutions-btn {
      p {
        color: #ffffff;
      }
      i {
        color: #ffffff;
      }
    }
  }
  .solutions-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #E05807;
    }
    i {
      font-size: 12px;
      color: #E05807;
      margin-left: 8px;
    }
  }
}
</style>
